import { render, staticRenderFns } from "./InfoboxContact.vue?vue&type=template&id=f4cf4f50&scoped=true&"
import script from "./InfoboxContact.vue?vue&type=script&lang=js&"
export * from "./InfoboxContact.vue?vue&type=script&lang=js&"
import style0 from "./InfoboxContact.vue?vue&type=style&index=0&id=f4cf4f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cf4f50",
  null
  
)

export default component.exports